// src/composables/useToast.js

import { ref } from 'vue';

// State reaktif yang akan menyimpan semua notifikasi
const toasts = ref([]);

export function useToast() {
  // Fungsi untuk menambahkan notifikasi baru
  const addToast = (message, type = 'info', duration = 5000) => {
    const id = Date.now() + Math.random();
    
    // Tambahkan notifikasi ke dalam array
    toasts.value.push({ id, message, type });

    // Set timeout untuk menghapus notifikasi secara otomatis
    setTimeout(() => {
      removeToast(id);
    }, duration);
  };

  // Fungsi untuk menghapus notifikasi berdasarkan ID-nya
  const removeToast = (id) => {
    const index = toasts.value.findIndex(toast => toast.id === id);
    if (index > -1) {
      toasts.value.splice(index, 1);
    }
  };

  return {
    toasts,
    addToast,
    removeToast
  };
}